import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import LogActivityService from "service/LogActivity";

export const getAllLogActivities =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterGroupActivity: string = "",
    filterPortal: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_LOG_ACTIVITY_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_LOG_ACTIVITY",
      searchValue: search,
    });

    try {
      const data = await LogActivityService.getLogActivities(
        page,
        search,
        limit,
        filterGroupActivity,
        filterPortal
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_LOG_ACTIVITY", value: data.log_activities });
      dispatch({
        type: "SET_LOG_ACTIVITY_PAGE",
        totalPage: !!data.log_activities.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.log_activities.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_LOG_ACTIVITY_FILTER_PAGE",
        filterGroupActivityPage: filterGroupActivity,
        filterPortalPage: filterPortal,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

  export const getAllGroupActivies =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FILTER_LOADING", value: true });

    try {
      const data = await LogActivityService.getAllGroupActivies();

      dispatch({ type: "SET_FILTER_LOADING", value: false });
      dispatch({
        type: "SET_LOG_ACTIVITY_GROUP",
        value: data.group_activities,
      });
    } catch (err: any) {
      dispatch({ type: "SET_FILTER_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
